import { LOGIN_INTENTS } from "@/modules/auth/loginIntent";

const ONBOARDING_PATH = "/myAccount/onboarding";

/** Preserves the acquisition context across authentication without an open redirect. */
export const personalizedDemoDestination = (
  isAuthenticated: boolean,
): string => {
  if (isAuthenticated) return ONBOARDING_PATH;

  const callbackUrl = encodeURIComponent(ONBOARDING_PATH);
  return `/login?callbackUrl=${callbackUrl}&intent=${LOGIN_INTENTS.personalizedDemo}`;
};

